import React from 'react';

import Label from 'ui-library/bs/Label';
import {FieldRequiredIndicator} from 'ui-library/inputs/FieldLabel';

interface LabelWrapperProps {
  label: string | null;
  required?: boolean | null;
}

function LabelWrapper(props: LabelWrapperProps): JSX.Element {
  return (
    <Label style={{paddingLeft: '0px'}}>
      {props.label}
      {props.required && <FieldRequiredIndicator />}
    </Label>
  );
}

export default LabelWrapper;
